import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { STColumn, STComponent, STReq, STRes, STPage } from '@delon/abc';
import { NzModalRef } from 'ng-zorro-antd';
import { DialogService } from '../../../services/dialog.service';
import { _MSGTYPES } from '../../../constant/msgType';
import { URLS } from '../../../constant/interface';

const SERVICE_NUM = 0;
const SUBSCRIPTION_NUM = 1;

/**
 * 渠道管道操作
 * - `hidden` 控制显影
 * - `disable` 是否可选
 */
export interface ChannelPipe {
  hidden?: (channels: any) => boolean;
  disable?: (channels: any) => boolean;
}

@Component({
  templateUrl: './channel.component.html',
})
export class ChannelComponent implements OnInit, AfterViewInit {
  title = '选择渠道';
  subject = '渠道绑定';
  channelProvider: any;
  msgType: string;
  msgTypes: [];
  carrierId: number;
  url: string;
  selectedChannels: any[];
  req: STReq = {
    type: 'page',
    method: 'POST',
    allInBody: true,
    lazyLoad: true,
  };

  pipe: ChannelPipe = {};

  res: STRes = {
    process: (data, rawData) => {
      if (this.channelProvider.channels) {
        const binds = [];
        data.forEach(d => {
          const bind = this.channelProvider.channels.find(bd => bd.channelId === d.id);
          if (bind) {
            d.checked = true;
            binds.push(d);
          }
        });
        this.selectedChannels = binds;
      }
      if (this.pipe.hidden) {
        const temp = data.filter(item => !this.pipe.hidden(item));
        return temp;
      }
      return data;
    },
  };

  // 消息类型常量
  MT = {
    wechat: null,
    tiktok: null,
    jpush: null,
    sms: null,
    voice: null,
    email: null,
    workwx: null,
    _5G: null,
  };

  page: STPage = {
    show: false,
  };
  @ViewChild('st', { static: false }) st: STComponent;
  columns: STColumn[] = [
    {
      title: '编号',
      width: 70,
      index: 'selected',
      type: 'checkbox',
      className: 'text-center',
      iif: item => {
        return !(this.msgType === this.MT.wechat || this.msgType === this.MT.tiktok || this.msgType === this.MT.jpush || this.msgType === this.MT.workwx || this.msgType === this.MT._5G);
      },
    },
    {
      title: '编号',
      width: 70,
      index: 'selected',
      type: 'radio',
      className: 'text-center',
      iif: item => {
        return this.msgType === this.MT.wechat || this.msgType === this.MT.tiktok || this.msgType === this.MT.jpush || this.msgType === this.MT.workwx || this.msgType === this.MT._5G;
      },
    },
    {
      title: '渠道名称',
      width: 250,
      // index: 'name',
      render: 'tpl-name',
      className: 'text-center',
      iif: item => {
        return this.msgType === this.MT.sms || this.msgType === this.MT.voice || this.msgType === this.MT._5G;
      },
    },
    {
      title: '公众号名称',
      index: 'name',
      className: 'text-center',
      format: (item, _col, index) => {
        const name = item.name;
        const wechatType = item.wechatType === SERVICE_NUM ? '服务号' : '订阅号';
        return name + '【' + wechatType + '】';
      },
      iif: item => {
        return this.msgType === this.MT.wechat;
      },
    },
    {
      title: '邮箱名称',
      index: 'name',
      className: 'text-center',
      iif: item => {
        return this.msgType === this.MT.email;
      },
    },
    {
      title: '用户昵称',
      index: 'name',
      className: 'text-center',
      iif: item => {
        return this.msgType === this.MT.tiktok;
      },
    },
    {
      title: 'APP名称',
      index: 'name',
      className: 'text-center',
      iif: item => {
        return this.msgType === this.MT.jpush;
      },
    },
    {
      title: '渠道号',
      className: 'text-center',
      index: 'channelNum',
      iif: item => {
        return this.msgType === this.MT.sms || this.msgType === this.MT.voice;
      },
    },
    {
      title: '邮箱地址',
      className: 'text-center',
      index: 'channelNum',
      iif: item => {
        return this.msgType === this.MT.email;
      },
    },
    {
      title: '抖音号',
      className: 'text-center',
      index: 'channelNum',
      iif: item => {
        return this.msgType === this.MT.tiktok;
      },
    },

    {
      title: '渠道标识号',
      width: 200,
      className: 'text-center',
      // index: 'identity',
      render: 'tpl-identity',
      iif: item => {
        return this.msgType === this.MT.jpush || this.msgType === this.MT._5G;
      },
    },
    {
      title: '所属运营商',
      className: 'text-center',
      index: 'carrierName',
      iif: item => {
        return this.msgType === this.MT.sms;
      },
    },
    {
      title: '所属地区',
      className: 'text-center',
      index: 'regionName',
      iif: item => {
        return this.msgType === this.MT.sms || this.msgType === this.MT.voice;
      },
    },
    {
      title: '可发送信息类型',
      className: 'text-center',
      index: 'msgTypeStr',
      iif: item => {
        return this.msgType === this.MT.sms;
      },
    },
    {
      title: '渠道地址',
      width: 250,
      className: 'text-center',
      // index: 'senderAddress',
      render: 'tpl-senderAddress',
      iif: item => {
        return this.msgType === this.MT._5G;
      },
    },
    {
      title: '企业微信号',
      index: 'name',
      className: 'text-center',
      iif: item => {
        return this.msgType === this.MT.workwx;
      },
    },
    {
      title: '应用名称',
      index: 'channelNum',
      className: 'text-center',
      iif: item => {
        return this.msgType === this.MT.workwx;
      },
    },
  ];

  constructor(private modal: NzModalRef, private dialogService: DialogService) {}

  ngOnInit() {
    this.MT.sms = _MSGTYPES.MT.SMS.type.toString();
    this.MT.wechat = _MSGTYPES.MT.WECHAT.type.toString();
    this.MT.voice = _MSGTYPES.MT.VOICE.type.toString();
    this.MT.email = _MSGTYPES.MT.EMAIL.type.toString();
    this.MT.jpush = _MSGTYPES.MT.JPUSH.type.toString();
    this.MT.tiktok = _MSGTYPES.MT.TIKTOK.type.toString();
    this.MT.workwx = _MSGTYPES.MT.WORKWX.type.toString();
    this.MT._5G = _MSGTYPES.MT._5G.type.toString();

    this.req.params = {
      params: {
        providerId: this.channelProvider.id,
        msgType: Number(this.msgType),
      },
    };
    if (this.msgType === this.MT.sms || this.msgType === this.MT._5G) {
      // SMS or 5G
      this.req.params.params.carrierId = this.carrierId;
    }

    this.url = URLS.biztypeChannel.url;
  }

  ngAfterViewInit() {
    this.st.load();
    // 表格load后再监听
    this.st.change.subscribe(e => {
      if (e.type === 'checkbox') {
        this.selectedChannels = e.checkbox;
      } else if (e.type === 'radio') {
        this.selectedChannels = [e.radio];
      }
    });
  }

  confirm() {
    if (this.channelProvider.channelProportion < this.selectedChannels.length) {
      this.dialogService.notification.warning(this.subject, '所选渠道数必须小于等于渠道商百分比');
      return;
    }

    if (this.msgType === this.MT.wechat && this.msgTypes.length > 1 && this.selectedChannels.length === 1 && this.selectedChannels[0].wechatType === SUBSCRIPTION_NUM) {
      this.dialogService.notification.warning(this.subject, '由于微信管控限制，公众号类型为【订阅号】时，只允许使用微信此消息类型');
      return;
    }
    this.modal.close(this.selectedChannels);
  }

  cancel() {
    this.modal.triggerCancel();
  }
}
